import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

// documentation https://docs.affirm.com/payments/docs/html-reference
export interface AffirmCTAProps {
  amount: string | number;
  type?: 'product' | 'cart';
  className?: string | false;
}

const AffirmCTA = ({ amount, className, type = 'product' }: AffirmCTAProps) => {
  if (!amount) return null;
  return (
    <p
      className={classNames(
        'affirm-as-low-as [&_a]:tw-underline [&_a]:hover:tw-underline tw-pb-5',
        className,
      )}
      data-page-type={type}
      data-amount={Number(Number(amount).toFixed(2)) * 100}
    />
  );
};

export default AffirmCTA;
